module.exports = __webpack_public_path__ + "img/mail.f3e33038.svg";